import { Form_ProcessAreaTextField } from './Form_ProcessAreaTextField';
import { Form_WorkflowRepresentationTextField } from './Form_WorkflowRepresentationTextField';
import { Form_ImageAttachmentTextField } from './Form_ImageAttachmentTextField';
import { Form_VideoAttachmentTextField } from './Form_VideoAttachmentTextField';

export const ReferenceInputs = {
    ProcessArea: Form_ProcessAreaTextField,
    WorkflowRepresentation: Form_WorkflowRepresentationTextField,
    ImageAttachment: Form_ImageAttachmentTextField,
    VideoAttachment: Form_VideoAttachmentTextField,
};
